var parser = new UAParser();
var result = parser.getResult();
if(result.browser.name == 'IE' && result.browser.major == 11){
    document.getElementsByName('html').classList.add("ie11");
}
if(
    (result.browser.name == 'Chrome' && result.browser.major <= 78) ||
    (result.browser.name == 'Edge' && result.browser.major < 79) ||
    (result.browser.name == 'Firefox' && result.browser.major < 75) ||
    (result.browser.name == 'Safari' && result.browser.major <= 12) ||
    (result.browser.name == 'Opera' && result.browser.major <= 66)) {
    document.getElementsByName('html').classList.add("noclamp");
}
